import type { Identifier } from "ra-core";
import { useTranslate } from "ra-core";

import { EditSheet, type EditSheetProps } from "../misc/EditSheet";
import { CompanyInputs } from "./CompanyInputs";
import { withHttps } from "./companyModel";

export interface CompanyEditSheetProps extends Pick<EditSheetProps, "history"> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companyId: Identifier;
}

/**
 * Mobile company edit form (full-screen FormSheet). It is always opened over
 * the company's show page, so a successful save just closes it: no redirect.
 */
export const CompanyEditSheet = ({
  open,
  onOpenChange,
  companyId,
  history,
}: CompanyEditSheetProps) => {
  const translate = useTranslate();
  return (
    <EditSheet
      resource="companies"
      id={companyId}
      title={translate("resources.companies.action.edit")}
      open={open}
      onOpenChange={onOpenChange}
      transform={withHttps}
      redirect={false}
      history={history}
    >
      <CompanyInputs />
    </EditSheet>
  );
};
